<template>
    <div>
        <headerpage :status="1"></headerpage>
        <div class="box" :style="{height:height+'px'}">
            <img :src="detail.show_pic | addurl" style="width: 100%;height: 100%;position: absolute;top: 0;" />
            <img src="../../assets/images/qie/10.png" class="box_top_img" />
        </div>
        <div class="box1 adaptation">
            <div class="box1_cent" style="margin-bottom: 80px;">
                <img class="box1_cent_left" :src="detail.image_one | addurl" />
                <div class="box1_cent_right">
                    {{detail.title_one}}
                </div>
            </div>
            <div class="box1_cent" style="justify-content: flex-start;">

                <div class="box1_cent_right">
                    {{detail.title_two}}
                </div>
                <img class="box1_cent_left" style="right:0;left: auto;" :src="detail.image_two | addurl" />
            </div>
        </div>
    </div>
</template>
  
<script>
import headerpage from '../../components/header/header.vue';
import windowchange from '@/util/window'
import { mapGetters } from 'vuex'
export default {
    components: { headerpage },
    mixins: [windowchange],
    computed: {
        ...mapGetters({
            common: 'user/common',
        }),
    },
    data() {
        return {
            detail:''
        }
    },
    methods: {
        introduce_us() {
            this.$https.post(
                {
                    api: this.$api.api.demo.introduce_us,
                    type: "formData",
                },
                {},
                (response) => {
                    this.detail = response.data
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    },
    created: function () {

        this.introduce_us()
    }
}
</script>
  
<style scoped>
.box {

    background-size: 100% 100%;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.box_top_img {
    width: 905px;
    /* height: 51px; */
    position: absolute;
    top: 12%;
}

.box1 {
    margin: 80px auto;
    max-width: 70%;
    min-width: 1200px;

}

.box1_cent {
    display: flex;
    align-items: center;
    min-height: 330px;
    background-color: #f5f5f5;
    position: relative;
    justify-content: flex-end;
}

.box1_cent_left {
    width: 50%;
    height: 100%;
    min-height: 330px;
    position: absolute;
    left: 0;
}

.box1_cent_right {
    width: 50%;
    padding: 40px;
    background-color: #f5f5f5;
    min-height: 330px;
    font-size: 16px;
    color: #717171;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>


// WEBPACK FOOTER //
// index.vue?00a88e78